import MeritPoint from "./MeritPoint";

const items = [
  {
    number: "1",
    title: "購入単価・購入量がアップします！",
    description: "「せっかく送るならもっと買いたい」というお客さまによる追加の購入が期待できます。",
  },
  {
    number: "2",
    title: "購入機会の損失を防ぎます！",
    description: "商品をお渡しするのに時間がかかるものや店舗に在庫がない時も、先に海外配送の受付を済ませておけば販売が可能です。",
  },
  {
    number: "3",
    title: "訪日客以外も利用できます！",
    description: "日本人のお客さまのご利用やサンプル品の配送も可能です。",
  },
  {
    number: "4",
    title: "免税で送れます！",
    description: "11月からスタートする「新直送制度」を使用して免税した商品を配送できます。",
  },
];

const Merit = () => {
  return (
    <div
      className="w-full max-w-[1100px] md:w-[100%] mx-auto mb-8 md:mb-24"
      id="Recommendation"
    >
      <h2 className="mb-2 md:mb-10">
        Beaver Deliveryは
        <br />
        こんなメリットがあります
      </h2>

      <div className="flex flex-col gap-4 md:gap-6">
        {items.map((item) => (
          <div
            key={item.number}
            className="overflow-hidden rounded-[4px] md:rounded-[8px] border-[4px] md:border-[8px] border-[#F6C544]"
          >
            <div className="flex items-center gap-6 bg-[#F6C544] px-3 md:px-12 py-4 md:py-6">
              <span
                className="text-[16px] md:text-[48px] font-bold text-white"
                style={{ fontFamily: '"Rounded Mplus 1c"' }}
              >
                {item.number}
              </span>

              <h3 className="text-[13px] md:text-[30px] font-bold">
                {item.title}
              </h3>
            </div>

            <div className="bg-[#fff] px-3 md:px-12 py-4 md:py-6">
              <p className="text-[13px] md:text-[24px] leading-[1.7] text-left">
                {item.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
    };

export default Merit;